import React from "react";
import { Switch, Route } from "react-router-dom";
import Logout from "views/Logout/Logout.jsx";

import config from "config.js";
function BlankLayout(props) {
  return (
    <Switch>
      <Route path={config.MYACCOUNT.APP_PATH + "/will/logout"}>
        <Logout />
      </Route>
    </Switch>
  );
}

export default BlankLayout;
